// extracted by mini-css-extract-plugin
export default {"main":"styles_main__7y6dl","box":"styles_box__CrKZK"};